import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { UNAUTHORIZED_MESSAGE, userRoles } from 'src/constants/auth.constants'
import { TOAST_VARIANTS } from 'src/constants/toast.constants'
import { ROUTES } from 'src/lib/routes'
import { RootState } from 'src/redux/stores/store'

import { showToast } from '../toastNotification/toastNotification'

interface ProtectedRouteProps {
  allowedRoles?: string[]
  children: React.ReactNode
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  allowedRoles = [
    userRoles.CORPORATE_CREATE,
    userRoles.CORPORATE_VIEW,
    userRoles.DIVISION_CREATE,
    userRoles.DIVISION_VIEW,
  ],
  children,
}) => {
  const { readableUserRoles } = useSelector((state: RootState) => state.Auth)
  const hasAccess = readableUserRoles.some((role) =>
    allowedRoles.includes(role)
  )
  const navigate = useNavigate()

  useEffect(() => {
    // Redirect non-allowed routes for current user
    if (readableUserRoles.length > 0 && !hasAccess) {
      showToast({
        message: UNAUTHORIZED_MESSAGE,
        type: TOAST_VARIANTS.WARNING,
      })
      navigate(ROUTES.HOME, { replace: true })
    }
  }, [readableUserRoles, hasAccess])

  // Wait for user role to be loaded before making routing decisions
  if (readableUserRoles.length === 0) {
    return null
  }

  return <>{children}</>
}
